import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLongArrowAltRight } from '@fortawesome/free-solid-svg-icons';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import { useHistory } from 'react-router';
import { divide } from 'lodash';
import SupportImage from '../../../assets/images/Support_image.png';
import StageCompleted from '../../../assets/images/Support_Completed.png';
import '../supportOpen/style.css';

const useStyles = makeStyles((theme) => ({
    supCardImg: {
        width: '100%',
        // height: '100%',
        // border: '1px solid black',
        // position: 'relative',
        '& img': {
            margin: '20px auto',
            display: 'block',
            // maxHeight: '100%',
            // maxWidth: '100%',
            // position: 'absolute',
            // top: '0',
            // bottom: '0',
            // left: '0',
            // right: '0',
            // margin: 'auto',
        },
    },
    heading: {
        fontFamily: 'Rubik',
        fontSize: '30px',
        fontWeight: 300,
        textAlign: 'center',
        color: '#515151',
        margin: '30px 0',
    },
    button: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        textTransform: 'capitalize',
        padding: '6px 10px',
        letterSpacing: 'normal',
        width: '100%',
    },
    btnspace: {
        marginTop: '10px',
        width: '100%',
    },
    txtnormal: {
        fontFamily: 'Rubik',
        fontSize: '15px',
    },
    txtbold: {
        fontWeight: '500',
        fontFamily: 'Rubik',
        fontSize: '15px',
    },
    fontstyle: {
        fontFamily: 'Rubik',
        fontSize: '15px',
    },
}));

export default function SupportCompleted({ letter, index, handleSave }) {
    const classes = useStyles();
    const history = useHistory();
    // const [body, setBody] = useState(letter.engagementBody);
    // const [subject, setSubject] = useState(letter.engagementSubject);

    // const navigate = () => {
    //     history.push('/menu/bankclients');
    // };

    return (
        <>
            <Card className="client-card">
                <CardContent className="client-heading">
                    <Typography variant="h5">Support</Typography>
                </CardContent>
                <CardContent>
                    {/* <CardHeader className="borderBottomLine ptb24" title="Support" /> */}
                    <Grid item container spacing={3}>
                        <Grid item xs={12} sm={6}>
                            <div className={classes.supCardImg}>
                                <img src={SupportImage} alt="Supportimage" />
                                <img src={StageCompleted} alt="Supportcompleted" />
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Grid container spacing={3} className="main-container">
                                <Grid item xs={6} sm={4} className={classes.txtbold}>
                                    <div>
                                        <Typography variant="span">Ticket Number</Typography>
                                    </div>

                                    <div>
                                        <Typography variant="span">Issue related to</Typography>
                                    </div>
                                </Grid>
                                <Grid item xs={6} sm={8} className={classes.txtnormal}>
                                    <div>
                                        <Typography variant="span">0001</Typography>
                                    </div>

                                    <div>
                                        <Typography variant="span">Service</Typography>
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid container spacing={3} className="main-container ptb0">
                                <Grid item xs={4} sm={2}>
                                    <div className="bgBlue">
                                        <div className="support-date">
                                            <Typography gutterBottom variant="title">
                                                07
                                            </Typography>
                                        </div>
                                        <div className="support-month">
                                            <Typography variant="caption" noWrap>
                                                Jan
                                            </Typography>
                                        </div>
                                        <div className="support-time">
                                            <Typography variant="caption" noWrap>
                                                01am
                                            </Typography>
                                        </div>
                                    </div>
                                </Grid>
                                <Grid item xs={8} sm={10}>
                                    <div>
                                        <Typography variant="Title" className={classes.txtbold}>
                                            Advith:{' '}
                                        </Typography>
                                        <Typography variant="caption" className={classes.fontstyle}>
                                            Lorem Ipsum is simply dummy text of the priniting and typesetting industry.{' '}
                                        </Typography>
                                    </div>
                                    <div className={classes.fullWidth}>
                                        <FormControl className={classes.btnspace}>
                                            <Button variant="outlined" color="primary" className={classes.button}>
                                                View attached document
                                            </Button>
                                        </FormControl>
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid container spacing={3} className="main-container ptb0">
                                <Grid item xs={4} sm={2}>
                                    <div className="bgBlue">
                                        <div className="support-date">
                                            <Typography gutterBottom variant="title">
                                                08
                                            </Typography>
                                        </div>
                                        <div className="support-month">
                                            <Typography variant="caption" noWrap>
                                                Jan
                                            </Typography>
                                        </div>
                                        <div className="support-time">
                                            <Typography variant="caption" noWrap>
                                                08am
                                            </Typography>
                                        </div>
                                    </div>
                                </Grid>
                                <Grid item xs={8} sm={10}>
                                    <div>
                                        <Typography variant="Title" className={classes.txtbold}>
                                            Advith:{' '}
                                        </Typography>
                                        <Typography variant="caption" className={classes.fontstyle}>
                                            Issue got resolved
                                        </Typography>
                                    </div>
                                    {/* <div className={classes.fullWidth}>
                                        <FormControl className={classes.btnspace}>
                                            <Button variant="outlined" color="primary" className={classes.button}>
                                                View attached document
                                            </Button>
                                        </FormControl>
                                    </div> */}
                                </Grid>
                            </Grid>
                            <Grid container spacing={3} className="main-container">
                                <Grid item xs={12} sm={12}>
                                    <FormControl fullWidth>
                                        <InputLabel className="lbl" htmlFor="description" shrink>
                                            Message
                                        </InputLabel>
                                        <Input type="text" className="bottom" placeholder="Enter Message" name="message" />
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>

            <div className="footer-button">
                <ul>
                    <li>
                        <Button color="primary" className="buttonnext txt-cap" type="submit">
                            Close
                        </Button>
                    </li>
                </ul>
            </div>
        </>
    );
}
